export default __webpack_public_path__ + "static/8-1a219ad986a878bc6bbe323a9a8f8d38.png";